<template>
  <v-layout row id="global-footer">
    <v-flex md12>
      <footer>
        <nav>
          <ul>
            <template v-if="isPrev">
              <li v-for="item in footer">
                <a :href="'/footer/' + item.slug">{{ item.title }}</a>
              </li>
            </template>
            <template v-else>
              <li><a href="/about">サービス概要</a></li>
              <li><a href="/faq">よくある質問</a></li>
              <li><a href="/commercial">特定商取引についての表記</a></li>
              <li><a href="/terms">利用規約</a></li>
              <li><a href="/privacy">プライバシーポリシー</a></li>
              <li><a href="/site_policy">サイトポリシー</a></li>
            </template>
            <li><a href="/posts/26472">NCBについて</a></li>
            <li><a href="/teammembers">チームメンバー</a></li>
            <li><a href="/contact">お問い合わせ</a></li>
          </ul>
          <div class="footer-sns-list">
            <!-- <a href="https://www.facebook.com/groups/ncblounge">
              <img src="/images/facebook-icon-white.svg" class="sns-icon">
            </a> -->
            <a href="https://twitter.com/ncb_since1989" target="_blank">
              <img src="/images/x-logo-white.png" class="sns-icon-small" />
            </a>
            <a href="https://www.youtube.com/c/NCBLounge" target="_blank">
              <img src="/images/youtube-icon-white.png" class="sns-icon" />
            </a>
          </div>
        </nav>
        <p><small>Copyright © NCB Lab. All right reserved.</small></p>
      </footer>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ["user", "footer", "isPrev"],
};
</script>

<style lang="scss">
@import "../../sass/variables";

// Medium ~
@media (min-width: 751px) {
  #global-footer {
    footer {
      @include centerXY;
      flex-wrap: wrap;
      background: $cBaseDk;
      nav {
        ul {
          @include centerX;
          list-style-type: none;
          padding-top: 50px;
          flex-wrap: wrap;
          li {
            padding: 0 20px;
            margin-bottom: 10px;
            margin-right: 20px;
            a {
              opacity: 0.6;
              color: white;
              &:hover {
                opacity: 1;
              }
            }
          }
        }
        .footer-sns-list {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          border-bottom: 1px solid white(15);
          padding: 20px 0;
          & > a {
            margin-right: 15px;
            display: flex;
            align-items: center;
            .sns-icon {
              width: 35px;
              height: 35px;
              object-fit: contain;
            }
            .sns-icon-small {
              width: 30px;
              height: 30px;
              object-fit: contain;
            }
          }
        }
      }
      p {
        width: 100%;
        margin-bottom: 0;
        padding: 15px 0;
        text-align: center;
        color: white(30);
      }
      small {
      }
    }
  }
}
// Small
@media screen and (max-width: 750px) {
  #global-footer {
    footer {
      @include centerXY;
      flex-wrap: wrap;
      background: $cBaseDk;
      nav {
        ul {
          @include centerX;
          flex-wrap: wrap;
          list-style-type: none;
          padding: 45px 0;
          li {
            width: 100%;
            padding: 5px 20px;
            text-align: center;
            a {
              opacity: 0.6;
              color: white;
              &:hover {
                opacity: 1;
              }
            }
          }
        }
        .footer-sns-list {
          display: none;
        }
      }
      p {
        width: 100%;
        margin-bottom: 0;
        padding: 15px 0;
        font-size: 0.8rem !important;
        text-align: center;
        color: white(30);
      }
      small {
      }
    }
  }
}
</style>
